import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { io } from "socket.io-client";
import { environment } from '../../environments/environment';
import { ApiserviceService } from '../apiservice.service';

@Injectable({
  providedIn: "root",
})
export class SocketService {
  socket: any;
  socket1: any;
  socketEms: any;

  public message$: BehaviorSubject<string> = new BehaviorSubject("");
  public bulkApprovedAccpet$: BehaviorSubject<any> = new BehaviorSubject(null);
  public progress$: BehaviorSubject<string> = new BehaviorSubject("");
  public masterServiceListener$: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(private readonly apiservice: ApiserviceService) {}

  initSockets() {
    if (!this.socket && this.apiservice.city_id) {
      this.socket = io(environment.csvUrl, {
        extraHeaders: {
          "user-city": this.apiservice.city_id,
          "user-id": this.apiservice.user_id,
        },
      });

      this.socket1 = io(environment.epsUrl, {
        extraHeaders: {
          "user-city": this.apiservice.city_id,
          "user-id": this.apiservice.user_id,
        },
      });

      this.socketEms = io(environment.emsUrl, {
        extraHeaders: {
          "user-city": this.apiservice.city_id,
          "user-id": this.apiservice.user_id,
        },
      })

      this.socket.on("message", (message) => {
        this.message$.next(message);
      });

      this.socket1.on("sync_message", (progress) => {
        this.progress$.next(progress);
      });

      this.socket1.on("bulk_approved_accept_notification", (data) => {
        console.log(data,'data from socket 1');

        this.bulkApprovedAccpet$.next(data);
      });


      this.socket.on("bulk_approved_accept_notification", (data) => {
        console.log(data,'data from socket');

        this.bulkApprovedAccpet$.next(data);
      });

      //ems socket listener
      this.socketEms.on("master_service_listener", (data) => {
        this.masterServiceListener$.next(data);        
      })

    }
  }
}
